import { render, staticRenderFns } from "./target-size.vue?vue&type=template&id=185b81de&scoped=true&"
import script from "./target-size.vue?vue&type=script&lang=ts&"
export * from "./target-size.vue?vue&type=script&lang=ts&"
import style0 from "./target-size.vue?vue&type=style&index=0&id=185b81de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185b81de",
  null
  
)

export default component.exports